import {ResourceParams, resources} from "../../../../models/resource/resources";

export const bloggerDeduplicationModalName = 'blogger-deduplication';

export const bloggerResourceType: ResourceParams = resources['bloggers'];
export const bloggerDeduplicationPath = 'duplicate';
